import { IChannel } from '@/types/channel'
import axios from 'axios'

export const getChannels = async (): Promise<IChannel[]> => {
  const instance = axios.create()

  try {
    const { data } = await instance.get<IChannel[]>('channels')
    return data
  } catch {
    throw new Error('error.channels.getChannels')
  }
}
